import { render, staticRenderFns } from "./categoriasShare.vue?vue&type=template&id=47637931&scoped=true&"
import script from "./categoriasShare.vue?vue&type=script&lang=js&"
export * from "./categoriasShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47637931",
  null
  
)

export default component.exports